module.exports = __webpack_public_path__ + "img/pitt_keychain.142ee834.png";